import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h4", { class: "fs-5 fw-bold text-gray-800" }, " Share my referral link with friends ", -1)
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  ref: "copyButtonRef",
  id: "kt_share_earn_link_copy_button",
  class: "btn btn-light fw-bolder flex-shrink-0",
  "data-clipboard-target": "#ovi_survey_form_link"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_10 = {
  key: 0,
  id: "share-network-list"
}
const _hoisted_11 = {
  class: "border border-gray-300 border-dashed rounded py-3 px-4 me-6 mb-3",
  style: {"width":"900px !important"}
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  class: "row",
  align: "center"
}, [
  /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  Share Details")
], -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-12" }
const _hoisted_15 = { class: "row mt-5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 mb-3" }, [
  /*#__PURE__*/_createVNode("label", { class: "col-form-label  fw-bold fs-6" }, "Title:")
], -1)
const _hoisted_17 = { class: "col-lg-10 mb-3" }
const _hoisted_18 = { class: "row mt-5" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 mb-3" }, [
  /*#__PURE__*/_createVNode("label", { class: "col-form-label  fw-bold fs-6" }, "Description:")
], -1)
const _hoisted_20 = { class: "col-lg-10 mb-3" }
const _hoisted_21 = { class: "row mt-5" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 mb-3" }, [
  /*#__PURE__*/_createVNode("label", { class: "col-form-label  fw-bold fs-6" }, "Quote:")
], -1)
const _hoisted_23 = { class: "col-lg-10 mb-3" }
const _hoisted_24 = { class: "row mt-5" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 mb-3" }, [
  /*#__PURE__*/_createVNode("label", { class: "col-form-label  fw-bold fs-6" }, "Hashtags:")
], -1)
const _hoisted_26 = { class: "col-lg-10 mb-3" }
const _hoisted_27 = { class: "row mt-5" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "col-lg-2 mb-3" }, [
  /*#__PURE__*/_createVNode("label", { class: "col-form-label  fw-bold fs-6" }, "Share With:")
], -1)
const _hoisted_29 = { class: "col-lg-6 mb-3" }
const _hoisted_30 = /*#__PURE__*/_createVNode("option", { value: "" }, "Select One", -1)
const _hoisted_31 = { class: "col-lg-4 mb-3" }
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_34 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_35 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Importance Of Accident Protection"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Budget For Protection"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Number Of People To Cover"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Stays In The Philippines")
  ])
], -1)
const _hoisted_36 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_37 = { class: "text-muted fw-bold d-block mb-1" }
const _hoisted_38 = { class: "text-muted fw-bold d-block mb-1" }
const _hoisted_39 = { class: "rating" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("i", { class: "bi bi-star-fill fs-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _withDirectives(_createVNode("input", {
                ref: "inputRef",
                id: "ovi_survey_form_link",
                type: "text",
                class: "form-control form-control-solid me-3 flex-grow-1",
                name: "search",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.shareLink = $event))
              }, null, 512), [
                [_vModelText, _ctx.shareLink]
              ]),
              _createVNode("button", _hoisted_8, " Copy Link ", 512),
              _hoisted_9,
              (!this.showShareDiv)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn btn-light fw-bolder flex-shrink-0",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowShareDiv()))
                  }, " Share Now "))
                : _createCommentVNode("", true),
              (this.showShareDiv)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "btn btn-light fw-bolder flex-shrink-0",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowShareDiv()))
                  }, " Cancel Share "))
                : _createCommentVNode("", true)
            ])
          ]),
          (this.showShareDiv)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode("div", _hoisted_13, [
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("div", _hoisted_17, [
                          _withDirectives(_createVNode("textarea", {
                            rows: "4",
                            type: "text",
                            class: "form-control form-control-lg form-control-solid mb-2",
                            placeholder: "Title",
                            name: "share_title",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.sharing.title = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.sharing.title]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode("div", _hoisted_20, [
                          _withDirectives(_createVNode("textarea", {
                            rows: "4",
                            type: "text",
                            class: "form-control form-control-lg form-control-solid mb-2",
                            placeholder: "Description",
                            name: "share_desc",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sharing.description = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.sharing.description]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode("div", _hoisted_23, [
                          _withDirectives(_createVNode("textarea", {
                            rows: "4",
                            type: "text",
                            class: "form-control form-control-lg form-control-solid mb-2",
                            placeholder: "Quote",
                            name: "share_quote",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sharing.quote = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.sharing.quote]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode("div", _hoisted_26, [
                          _withDirectives(_createVNode("textarea", {
                            rows: "4",
                            type: "text",
                            class: "form-control form-control-lg form-control-solid mb-2",
                            placeholder: "Hashtags",
                            name: "share_hashtags",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.sharing.hashtags = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.sharing.hashtags]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("div", _hoisted_29, [
                          _withDirectives(_createVNode("select", {
                            class: "form-select form-select-solid form-select-lg fw-bold mb-2",
                            name: "share_socmed",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.share_socmed = $event))
                          }, [
                            _hoisted_30,
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.networks, (network) => {
                              return (_openBlock(), _createBlock("option", {
                                key: network.network,
                                value: network.network
                              }, _toDisplayString(network.network.toUpperCase()), 9, ["value"]))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.share_socmed]
                          ])
                        ]),
                        _createVNode("div", _hoisted_31, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.networks, (network) => {
                            return (_openBlock(), _createBlock(_Fragment, null, [
                              (network.network.toUpperCase() == _ctx.share_socmed.toUpperCase())
                                ? (_openBlock(), _createBlock(_component_ShareNetwork, {
                                    network: network.network,
                                    key: network.network,
                                    style: {backgroundColor: network.color},
                                    url: _ctx.shareLink,
                                    title: _ctx.sharing.title,
                                    description: _ctx.sharing.description,
                                    quote: _ctx.sharing.quote,
                                    hashtags: _ctx.sharing.hashtags,
                                    twitterUser: _ctx.sharing.twitterUser,
                                    class: "form-control"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode("i", {
                                        class: network.icon
                                      }, null, 2),
                                      _createVNode("span", null, "Share with" + _toDisplayString(network.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["network", "style", "url", "title", "description", "quote", "hashtags", "twitterUser"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_32,
        (!this.showShareDiv)
          ? (_openBlock(), _createBlock("div", _hoisted_33, [
              _createVNode("table", _hoisted_34, [
                _hoisted_35,
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", null, "   " + _toDisplayString(index + 1), 1),
                      _createVNode("td", null, [
                        _createVNode("a", _hoisted_36, _toDisplayString(item.nickname), 1),
                        _createVNode("span", _hoisted_37, _toDisplayString(item.email), 1),
                        _createVNode("span", _hoisted_38, _toDisplayString(item.cpnumber), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_39, [
                          _createVNode("div", {
                            class: ["rating-label me-2", item.howimportant > 0 ? 'checked' : '']
                          }, [
                            _hoisted_40
                          ], 2),
                          _createVNode("div", {
                            class: ["rating-label me-2", item.howimportant > 1 ? 'checked' : '']
                          }, [
                            _hoisted_41
                          ], 2),
                          _createVNode("div", {
                            class: ["rating-label me-2", item.howimportant > 2 ? 'checked' : '']
                          }, [
                            _hoisted_42
                          ], 2),
                          _createVNode("div", {
                            class: ["rating-label me-2", item.howimportant > 3 ? 'checked' : '']
                          }, [
                            _hoisted_43
                          ], 2),
                          _createVNode("div", {
                            class: ["rating-label me-2", item.howimportant > 4 ? 'checked' : '']
                          }, [
                            _hoisted_44
                          ], 2)
                        ])
                      ]),
                      _createVNode("td", null, _toDisplayString(item.allocated_budget), 1),
                      _createVNode("td", null, _toDisplayString(item.coverage_people), 1),
                      _createVNode("td", null, _toDisplayString(item.stayphil.toUpperCase()), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}